module.exports = __webpack_public_path__ + "img/1.e9fa7e38.png";